import React from "react"
import Button from "components/Button"
import ModalButtons from "components/ModalButtons"
import withForm from "hoc/withForm"
import withModal from "hoc/withModal"
import { localize } from "locale"
import withUrls from "hoc/withUrls"
import { P } from "styledComponents/Typography"
import * as R from "ramda"
import { stringRequired } from "validators/string"
import Radio from "inputs/Radio"
import {
  coworkerOptions,
  getCoworkerOptions,
} from "data/assessments/coworkerOptions"
import { involvedPartyRequest } from "data/cockpit/api"

const CreateAssessmentInvolvedPartyModal = ({ libraryItemId, close }) => (
  <>
    <P mb={20} bold>
      Select coworker option
    </P>

    <Radio
      options={getCoworkerOptions(!R.isNil(libraryItemId))}
      name="copyCoworkers"
      byValue
    />

    <ModalButtons>
      <Button secondary type="button" onClick={close} text="Cancel" />
      <Button primary type="submit" text={localize("continue")} />
    </ModalButtons>
  </>
)

export default R.compose(
  withModal(p =>
    R.isNil(p.libraryItemId)
      ? "Create assessment"
      : "Create assessment from library item",
  ),
  withUrls,
  withForm({
    mapProps: R.always({
      copyCoworkers: coworkerOptions.prefill.value,
    }),
    schema: R.always({
      copyCoworkers: stringRequired,
    }),
    onSubmit: p => v =>
      involvedPartyRequest.createAssessment(p.case_.id, p.involvedPartyId, {
        ...(p.libraryItemId
          ? {
              libraryItemAssessmentCreationOptions: {
                assessmentsCoworkersOption: v.copyCoworkers,
              },
              libraryItemId: p.libraryItemId,
            }
          : {
              templateAssessmentCreationOptions: {
                assessmentsCoworkersOption: v.copyCoworkers,
              },
              templateId: p.templateId,
            }),
      }),
    onSuccess: p => () => p.close(),
    redirect: (res, p) => p.redirect(res),
  }),
)(CreateAssessmentInvolvedPartyModal)
